module.exports = __webpack_public_path__ + "0da4ac4273ca16a21fd433801e78254a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/princeton_university_2023_chart.png
// module id = 1719
// module chunks = 0